export const formatChecklistLabel = (key: string) => {
  const temp = key.replace(/([A-Z])/g, ' $1');
  return `${temp.charAt(0).toUpperCase()}${temp.slice(1)}`;
};

export const formatChecklistValue = (value: string) =>
  value.replace(/([A-Z])/g, ' $1').trim();
